import css from 'styled-jsx/css';

export default css`
  .post {
    display: flex;
    justify-content: space-between;
    align-items: end;
    border-radius: 5px;
    background-color: #242424;
    padding: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }
  @media (max-width: 575px) {
    .post {
      padding: 10px;
    }
  }
  .post-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    gap: 10px;
  }
  @media (max-width: 575px) {
    .post-content {
      align-items: start;
      width: 100%;
    }
  }
  .post-title {
    width: 100%;
    margin: 0;
    display: block;
    padding: 5px 0;
    text-align: start;
    font-family: 'Roboto-Normal';
    font-size: 18px;
    font-weight: 600px;
  }
  @media (max-width: 767px) {
    .post-title {
      font-size: 13px;
    }
  }
  .post-tags {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
  .post-link {
    width: 25%;
    text-align: end;
    font-family: 'Roboto-Normal';
    font-size: 14px;
    font-weight: 600;
    color: #950810;
  }
  @media (max-width: 575px) {
    .post-link {
      font-size: 9px;
      font-weight: bold;
    }
  }
`;
